import AppContext from 'context/AppContext'
import { useContext } from 'react'

function useElementNames() {
  const { sorElementMapping } = useContext(AppContext)
  return sorElementMapping
}
export default useElementNames
